import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SysAdminService } from "../../../../services/sysadmin.service";

@Component({
	selector: "app-user-modify-add-user-groups",
	templateUrl: "./user-modify-add-user-groups.component.html",
	styleUrls: ["./user-modify-add-user-groups.component.css"],
})
export class UserModifyAddUserGroupsComponent implements OnInit {
	constructor(private dialogConfig: DynamicDialogConfig, private ref: DynamicDialogRef, private sysAdminService: SysAdminService) {}

	ngOnInit(): void {
		//Load data from parent
		this.UserLevelID = this.dialogConfig.data.UserLevelID;

		//Load data from DB
		this.loadUserGroups();
	}

	////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////
	lstSchool: any = [];
	UserLevelID: any = 0;

	lstUserGroups: any = [];
	SelectedGroups: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "UserGroupDesc", header: "User Group" },
		{ field: "SchoolCount", header: "# of Schools" },
		{ field: "PageCount", header: "# of Pages" },
	];

	////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	loadUserGroups() {
		//Get data from DB
		var result = this.sysAdminService.UserGroupSimpleInfoGetList(this.UserLevelID);
		result.subscribe(
			(response) => {
				this.lstUserGroups = response;
			},
			(error) => {}
		);
	}
	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		this.ref.close(this.SelectedGroups);
	}
	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////////

	////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	////////////////////////////////////////////////
}
